/* ============================================
   (FRENCH+FILLER)™ — Dynamic Interactions 2026
   Drag-scroll, scroll reveal, parallax
   ============================================ */

(function () {
  'use strict';

  /* ----- 1. DRAG-TO-SCROLL on all slider-component ----- */
  function initDragScroll() {
    document.querySelectorAll('slider-component .slider').forEach((slider) => {
      if (slider.dataset.dragInit) return;
      slider.dataset.dragInit = '1';

      let isDown = false;
      let startX;
      let scrollLeft;

      slider.style.cursor = 'grab';

      slider.addEventListener('mousedown', (e) => {
        // Don't interfere with buttons/links
        if (e.target.closest('a, button, input, select')) return;
        isDown = true;
        slider.style.cursor = 'grabbing';
        slider.style.scrollSnapType = 'none';
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        e.preventDefault();
      });

      slider.addEventListener('mouseleave', () => {
        if (!isDown) return;
        isDown = false;
        slider.style.cursor = 'grab';
        slider.style.scrollSnapType = '';
      });

      slider.addEventListener('mouseup', () => {
        if (!isDown) return;
        isDown = false;
        slider.style.cursor = 'grab';
        // Re-enable snap after a tiny delay so the last drag position sticks
        setTimeout(() => { slider.style.scrollSnapType = ''; }, 50);
      });

      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1.5; // multiplier for speed
        slider.scrollLeft = scrollLeft - walk;
      });
    });
  }

  /* ----- 2. SCROLL REVEAL (IntersectionObserver) ----- */
  function initScrollReveal() {
    const reveals = document.querySelectorAll('.ff-reveal');
    if (!reveals.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('ff-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    reveals.forEach((el) => observer.observe(el));
  }

  /* ----- 3. PARALLAX subtle on editorial images ----- */
  function initParallax() {
    const parallaxEls = document.querySelectorAll('.ff-parallax');
    if (!parallaxEls.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function onScroll() {
      parallaxEls.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const inView = rect.top < window.innerHeight && rect.bottom > 0;
        if (inView) {
          const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
          const offset = (progress - 0.5) * 60; // max ±30px
          el.style.transform = `translateY(${offset}px)`;
        }
      });
    }

    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => { onScroll(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ----- 4. STAGGER children animation ----- */
  function initStagger() {
    const staggerParents = document.querySelectorAll('.ff-stagger');
    if (!staggerParents.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const children = entry.target.querySelectorAll('.ff-stagger-child');
            children.forEach((child, i) => {
              child.style.transitionDelay = `${i * 120}ms`;
              child.classList.add('ff-revealed');
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    staggerParents.forEach((el) => observer.observe(el));
  }

  /* ----- 5. COUNTER animation for numbers ----- */
  function initCounters() {
    const counters = document.querySelectorAll('.ff-counter');
    if (!counters.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target;
            const target = parseInt(el.dataset.target, 10);
            const suffix = el.dataset.suffix || '';
            const duration = 1500;
            const start = performance.now();

            function step(now) {
              const progress = Math.min((now - start) / duration, 1);
              const eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
              el.textContent = Math.round(target * eased) + suffix;
              if (progress < 1) requestAnimationFrame(step);
            }
            requestAnimationFrame(step);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.5 }
    );

    counters.forEach((el) => observer.observe(el));
  }

  /* ----- 6. TRANSPARENT HEADER on homepage ----- */
  function initTransparentHeader() {
    if (!document.body.classList.contains('homepage')) return;

    var headerGroup = document.querySelector('.shopify-section-group-header-group');
    var headerWrapper = document.querySelector('.header-wrapper--transparent');
    if (!headerGroup || !headerWrapper) return;

    function setHeaderGroupHeight() {
      document.documentElement.style.setProperty('--ff-header-group-height', headerGroup.offsetHeight + 'px');
    }

    function shouldMeasureHeight() {
      var sectionHeader = headerGroup.querySelector('.section-header');
      return !sectionHeader || !sectionHeader.classList.contains('shopify-section-header-sticky');
    }

    setHeaderGroupHeight();

    // Recalcul : polices, images logo — pas quand le header est en fixed (la hauteur du groupe chute)
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        if (shouldMeasureHeight()) setHeaderGroupHeight();
      });
      ro.observe(headerGroup);
    }

    window.addEventListener('resize', function () {
      if (shouldMeasureHeight()) setHeaderGroupHeight();
    }, { passive: true });

    // Observe the hero to toggle transparent/opaque
    var hero = document.querySelector('#MainContent > .shopify-section:first-child');
    if (!hero) return;

    var observer = new IntersectionObserver(
      function (entries) {
        // When hero is not visible → opaque header
        headerWrapper.classList.toggle('header-wrapper--opaque', !entries[0].isIntersecting);
      },
      { threshold: 0, rootMargin: '-100px 0px 0px 0px' }
    );
    observer.observe(hero);
  }

  /* ----- INIT ----- */
  function init() {
    initDragScroll();
    initScrollReveal();
    initParallax();
    initStagger();
    initCounters();
    initTransparentHeader();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after Shopify section render (theme editor)
  document.addEventListener('shopify:section:load', init);
})();
